import React, { useState } from 'react';
import axios from 'axios';
import Reaptcha from 'reaptcha';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const Subscriber = (props) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const INITIAL_FORM_STATE = {
    EMAIL: props.email ? props.email : '',
    FIRSTNAME: '',
    OPT_IN: '1',
  };

  const FORM_VALIDATION = Yup.object().shape({
    FIRSTNAME: Yup.string().required('Required'),
    EMAIL: Yup.string().email('Invalid email').required('Required'),
  });
  return (
    <>
      <Grid container sx={{ backgroundColor: '#F2F1F1', margin: '0 auto', padding: '10px 0px' }}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              fontSize: '15px',
              fontWeight: '600',
              textAlign: 'center',
              color: '#35b73d',
              lineHeight: '1.6',
              display: 'block',
              margin: '10px',
            }}>
            Want to save money? But we don't know where to send you coupon code.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Container maxWidth="lg">
            <Box sx={{ fontSize: '1.0em' }}>
              <Formik
                initialValues={{
                  ...INITIAL_FORM_STATE,
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values) => {
                  const formData = new URLSearchParams();
                  //formData.append('EMAIL', values.EMAIL);
                  //formData.append('FIRSTNAME', values.FIRSTNAME);
                  //formData.append('OPT_IN', 1);
                  formData.append('mauticform[email]', values.EMAIL);
                  formData.append('mauticform[firstname]', values.FIRSTNAME);
                  formData.append('mauticform[site_id]', 'pagani');
                  formData.append('mauticform[formId]', '2');
                  formData.append('mauticform[return]', '');
                  formData.append('mauticform[formName]', 'paganicampaignsubscribe');
                  if (!values.EMAIL.endsWith('@163.com') && !values.EMAIL.endsWith('@126.com') && !values.EMAIL.endsWith('@qq.com')) {
                    axios
                      .post(
                        'https://m.paganidesignwatch.com/form/submit',
                        //sendinblue订阅，已废弃，改用mautic订阅, 'https://8c1b2556.sibforms.com/serve/MUIEAH2c-coDpUWBASEN57GhEiqemsMBdsMLwlHaL5_1SQSBJKLQa5hQxfKb22DnJecz5TFBYpo2yA1lVggq6GA8Eiz5LwpDMwb73QSrMz0D0or-RHYBD5HDQk5IMa7xnQpRt5f48_WLw8KU6vxi0GblVEhH-N_WM_6jIHTZQA15Nj5U8wdRHz4GUk8-UoBkkeEWhtAgHIgmL1cF',
                        formData,
                        {
                          headers: {
                            //accept: 'application/json',
                            'content-type': 'application/x-www-form-urlencoded',
                          },
                        }
                      )
                      .then((response) => {});
                  }
                  setOpen(true);
                }}>
                {(formik) => (
                  <Form>
                    <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={1}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          id="EMAIL"
                          name="EMAIL"
                          label="Email"
                          variant="outlined"
                          margin="dense"
                          size="small"
                          {...formik.getFieldProps('EMAIL')}
                          error={Boolean(formik.touched.EMAIL && formik.errors.EMAIL)}
                          helperText={formik.errors.EMAIL}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          id="FIRSTNAME"
                          name="FIRSTNAME"
                          label="FIRST NAME"
                          variant="outlined"
                          margin="dense"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          {...formik.getFieldProps('FIRSTNAME')}
                          error={Boolean(formik.touched.FIRSTNAME && formik.errors.FIRSTNAME)}
                          helperText={formik.errors.FIRSTNAME}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Reaptcha sitekey="6LeQ074cAAAAAKGH2PHT11p1cFlEqSKucsbftu8P" onload={() => {}} onVerify={() => {}} />
                      </Grid>

                      <Grid item xs={12}>
                        <Button fullWidth variant="contained" color="primary" type="submit" size="small" sx={{ marginTop: '8px' }}>
                          Send Me Coupon Code
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Alert onClose={handleClose} variant="filled" severity="info" sx={{ visibility: open ? 'visible' : 'hidden' }}>
                          Thanks for your subscription!
                        </Alert>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default Subscriber;
